// extracted by mini-css-extract-plugin
export default {"wrapper":"Hearings_wrapper__JCAGN","noText":"Hearings_noText__5r2r3"};